export default class SocketIOClient {
    constructor(config) {
        // //singleton
        // // do we have an existing instance?
        // if (typeof SocketIOClient.instance === 'object') {
        //     return SocketIOClient.instance;
        // }

        // // cache
        // SocketIOClient.instance = this;


        this.onMessage = function (data) { };
        this.onInvite = function (data) { };
        this.onInviteUserToRoom = function (data) { };
        this.onGameStart = function (data) { };
        this.onGetRoom = function (data) { };
        this.onUserDisconnected = function (data) { };
        this.onJoined = function (data) { };
        this.onRoomChanged = function (data) { };
        this.onPong = function (data) { };
        //default room
        this.defaultRoom = "theVoid";
        this.socket = null;

        this.config = config;
    }




connect(serverUrl, player) {
    if (!serverUrl) serverUrl = 'https://gameserverjimmy.azurewebsites.net';
    const socket = io(serverUrl);

    this.socket= socket;
    
    //socket = io(serverUrl, { 'forceNew': true });
    //var socket = io();
    // var socket = io('http://localhost:8001/');

    socket.on("connect",  () =>{
        //auto login
        this.login(player);
    });
    socket.on('login',  (data)=> {
        this.logMessage('<-- login', data);

        //todo: send message event
    });
    socket.on('message',  (data)=> {
        this.logMessage('<-- message', data);

        if (this.onMessage) this.onMessage(data);
    });
    socket.on('ping',  (data)=> {
        this.logMessage('<-- ping', data);

        // if (this.onPing) this.onPing(data);
    });
    socket.on('pong',  (data)=> {
        this.logMessage('<-- pong', data);

        if (this.onPong) this.onPong(data);
    });
    socket.on('gameStart',  (data)=> {
        this.logMessage('<-- gameStart', data);

        if (this.onGameStart) this.onGameStart(data);
    });
    socket.on('inviteUserToRoom',  (data)=> {
        this.logMessage('<-- inviteUserToRoom', data);

        if (this.onInviteUserToRoom) this.onInviteUserToRoom(data);
    });
    socket.on('invitation',  (data)=> {
        this.logMessage('<-- invitation', data);
        if (this.onInvite) this.onInvite(data);
    });


    socket.on('joined',  (data)=> {
        this.logMessage('<-- joined', data);
        if (this.onJoined) this.onJoined(data);
    });
    socket.on('roomChanged',  (data)=> {
        this.logMessage("<-- roomChanged", data);
        if (this.onRoomChanged) this.onRoomChanged(data);
    });
    socket.on('getRoom',  (data)=> {
        this.logMessage("<-- getRoom", data);

        if (this.onGetRoom) this.onGetRoom(data);
    });
    socket.on('userDisconnected',  (data)=> {
        this.logMessage("<-- userDisconnected", data);
        if (this.onUserDisconnected) this.onUserDisconnected(data);
    });
    socket.on('getRooms',  (data)=> {
        this.logMessage("<-- getRooms", data);

        //todo: send message event
    });

}
isConnected () {
    let socket = this.socket;
    if (!socket) return false;
    return socket.connected;
}
logMessage (event, data) {
    const config = this.config;
    if (config && config.DebugMode)
        console.log(event + " " + data);
}
login (player, room, os, version) {
    let socket = this.socket;
    if (!room) room = this.defaultRoom;

    if (player) {
        var user = {
            id: player.id,
            name: player.name || "NoName",
            avatar: player.avatar || "images/default-avatar.png",
            level: player.level || "1",
            rank: player.rank || "Bronze",
            rating: player.rating || 1000,
            os: player.os || os,
            version: player.version || version,
            noAutoJoinLobby: true
        }
        socket.emit('login', user, room);
    }
    this.logMessage("--> login", user);
};
sendMessage  (data) {
    let socket = this.socket;
    socket.emit('message', data);
    this.logMessage("--> message", data);
};
gameStart () {
    let socket = this.socket;
    socket.emit('gameStart');
    this.logMessage("--> gameStart");
}
joinRoom  (data) {
    let socket = this.socket;
    socket.emit('joinRoom', data);
    this.logMessage("--> joinRoom", data);
};
getUsers (data) {
    let socket = this.socket;
    socket.emit('getUsers', data);
    this.logMessage("--> getUsers", data);
};
getRooms  (data) {
    let socket = this.socket;
    socket.emit('getRooms', data);
    this.logMessage("--> getRooms", data);
};
getRoom (data) {
    let socket = this.socket;
    socket.emit('getRoom', data);
    this.logMessage("--> getRoom", data);
};
gameStart () {
    let socket = this.socket;
    //reset 
    socket.emit('gameStart');
    this.logMessage("--> gameStart");
};
inviteUserToRoom  (id, room) {
    let socket = this.socket;
    socket.emit('inviteUserToRoom', id, room);
    this.logMessage("--> inviteUserToRoom");
};
logPing  (ms) {
    let socket = this.socket;
    //reset 
    socket.emit('logPing', ms);
    this.logMessage("--> logPing");
};
destroy  () {
    let socket = this.socket;
    //destroy 
    console.log("socket.destroy");
    socket.destroy();
    socket.disconnect();
};




}